import { SVG_NAMESPACE } from '@recogito/annotorious/src/util/SVG';

/** Sets the ellipse attributes from its bounding box (x, y, w, h). */
export const setEllipseSize = (ellipse, x, y, w, h) => {
  ellipse.setAttribute('cx', x + w / 2);
  ellipse.setAttribute('cy', y + h / 2);
  ellipse.setAttribute('rx', Math.max(1, w / 2));
  ellipse.setAttribute('ry', Math.max(1, h / 2));
};

export const createEllipseElement = (className) => {
  const ellipse = document.createElementNS(SVG_NAMESPACE, 'ellipse');

  if (className) {
    ellipse.setAttribute('class', className);
  }

  ellipse.setAttribute('fill', 'none');

  return ellipse;
};

export const getEllipseStyle = (color, strokeWidth) =>
  `stroke:${color};stroke-width:${strokeWidth};fill:${color};fill-opacity:0.12`;

/**
 * Builds the W3C target for an ellipse annotation.
 *
 * Annotorious renders FragmentSelectors with its proven rectangle renderer,
 * while its SvgSelector renderer crashes on embedded SVG in this version.
 * The ellipse is therefore stored as its bounding box plus a `shape` marker:
 * the formatter draws the ellipse over the hidden rectangle.
 */
export const toEllipseTarget = (x, y, w, h, image) => ({
  source: image?.src,
  selector: {
    type: 'FragmentSelector',
    conformsTo: 'http://www.w3.org/TR/media-frags/',
    value: `xywh=pixel:${x},${y},${w},${h}`,
    shape: 'ellipse',
  },
});

export const isEllipseAnnotation = (annotationOrData) => {
  const data = annotationOrData?.underlying || annotationOrData || {};
  const target = Array.isArray(data.targets) ? data.targets[0] : data.target;
  const rawSelector = target?.selector;
  const selector = Array.isArray(rawSelector) ? rawSelector[0] : rawSelector;

  return selector?.type === 'FragmentSelector' && selector.shape === 'ellipse';
};
